import axios from '../axios'


export async function deleteCount(payload) {
    return axios.delete(`/inventory/counts/` + payload )
        .then((response) => {
        return response.data
    })
        .catch((error) => {
        return Promise.reject(error.response?.data || error)
    });
}

export async function createCount(payload) {
    return axios.post(`/inventory/counts`, { inventory_count: payload } )
    .then((response) => {
        return response.data
    })
    .catch((error) => {
        return Promise.reject(error.response?.data || error)
    });
}


export async function updateCount(payload) {
    return axios.put(`/inventory/counts/` + payload.id, { inventory_count: payload } )
    .then((response) => {
        return response.data
    })
    .catch((error) => {
        return Promise.reject(error.response?.data || error)
    });
}

export async function fetchCounts(payload = {}) {
    const params = new URLSearchParams();
    
    if (payload.query) {
        params.append('query', payload.query);
    }
    
    if (payload.filters && payload.filters.length > 0) {
        payload.filters.forEach(filter => {
            params.append('status[]', filter);
        });
    }
    
    if (payload.status) {
        if (Array.isArray(payload.status)) {
            payload.status.forEach(status => {
                params.append('status[]', status);
            });
        } else {
            params.append('status', payload.status);
        }
    }
    
    if (payload.page) {
        params.append('page', payload.page);
    }
    
    if (payload.per_page) {
        params.append('per_page', payload.per_page);
    }
    
    if (payload.sort) {
        params.append('sort', payload.sort);
    }
    
    if (payload.sortBy) {
        params.append('sort_by', payload.sortBy);
    }
    
    const queryString = params.toString();
    const url = `/inventory/counts${queryString ? '?' + queryString : ''}`;
    
    return axios.get(url)
    .then((response) => {
        return response.data
    })
    .catch((error) => {
        return Promise.reject(error.response?.data || error)
    });
}

export async function fetchCount(payload) {
    return axios.get(`/inventory/counts/` + payload)
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return Promise.reject(error.response?.data || error)
        });
}

export async function approveCount(countId, approved) {
    return axios.put(`/inventory/counts/${countId}/approve`, { approved })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return Promise.reject(error.response?.data || error)
        });
}

export async function setCountCoverage(countId, coverageType) {
    return axios.put(`/inventory/counts/${countId}/set_coverage`, { coverage_type: coverageType })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return Promise.reject(error.response?.data || error)
        });
}